import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import "./update-stock.css";

const UpdateStock = ({ onUpdate }) => {
  const familiesData = useSelector((state) => state.IngredientReducer?.families || []);
  const [selectedFamily, setSelectedFamily] = useState("");
  const [selectedIngredient, setSelectedIngredient] = useState("");
  const [newQuantity, setNewQuantity] = useState("");
  const [currentQuantity, setCurrentQuantity] = useState(0);
  const [currentPrice, setCurrentPrice] = useState(0);
  const [modificationDate, setModificationDate] = useState(null);

  useEffect(() => {
    const fetchCurrentStock = async () => {
      if (!selectedIngredient) return;

      try {
        const response = await axios.get(`/api/Stock/stockByIngredient/${selectedIngredient}`);
        setCurrentQuantity(response.data.totalQuantity);
        setCurrentPrice(response.data.averagePrice);
      } catch (error) {
        console.error("Erreur récupération stock actuel", error);
        alert("Impossible de récupérer le stock actuel");
      }
    };

    fetchCurrentStock();
  }, [selectedIngredient]);

  const handleUpdate = async () => {
    const updateDate = new Date();

    if (!selectedIngredient || !newQuantity) {
      alert("Veuillez remplir tous les champs");
      return;
    }

    try {
      const response = await axios.put("/api/Stock/update", {
        ingredient: selectedIngredient,
        totalQuantity: parseFloat(newQuantity),
        averagePrice: currentPrice
      });

      setModificationDate(updateDate);
      alert("Stock mis à jour !");
      onUpdate(response.data);

    } catch (error) {
      console.error("Erreur mise à jour", error);
    }
  };

  const difference = newQuantity !== "" 
    ? parseFloat(newQuantity) - currentQuantity 
    : 0;

  return (
    <div className="update-stock-container">
      <h2>Mise à jour du Stock</h2>

      <div className="form-group">
        <label>Famille</label>
        <select
          value={selectedFamily}
          onChange={(e) => {
            setSelectedFamily(e.target.value);
            setSelectedIngredient("");
          }}
        >
          <option value="">Choisir une famille</option>
          {familiesData.map((family) => (
            <option key={family._id} value={family._id}>
              {family.name}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>Ingrédient</label>
        <select
          value={selectedIngredient}
          onChange={(e) => setSelectedIngredient(e.target.value)}
          disabled={!selectedFamily}
        >
          <option value="">Choisir un ingrédient</option>
          {selectedFamily && 
            familiesData
              .find((f) => f._id === selectedFamily)
              ?.ingredients.map((ing) => (
                <option key={ing._id} value={ing._id}>
                  {ing.name}
                </option>
              ))}
        </select>
      </div>

      <div className="form-group">
        <label>Quantité Actuelle</label>
        <input type="text" readOnly value={currentQuantity.toFixed(3)} />
      </div>

      <div className="form-group">
        <label>Nouvelle Quantité</label>
        <input type="number" step="0.001" value={newQuantity} onChange={(e) => setNewQuantity(e.target.value)} />
      </div>

      <div className="form-group">
        <label>Différence</label>
        <input type="text" readOnly value={difference.toFixed(3)} style={{ color: difference < 0 ? 'red' : 'green', fontWeight: 'bold' }} />
      </div>

      <div className="form-group">
        <label>Prix Moyen Pondéré</label>
        <input type="text" readOnly value={`${currentPrice.toFixed(3)} DT`} />
      </div>

      <div className="form-group">
        <label>Date de Modification</label>
        <input type="text" readOnly value={modificationDate ? modificationDate.toLocaleDateString() : new Date().toLocaleDateString()} />
      </div>

      <button onClick={handleUpdate}>Mettre à jour</button>
    </div>
  );
};

export default UpdateStock;
